module.exports = new __parcel__URL__("earth_observation_trainings.d160a5bb.png").toString();